module.exports = __webpack_public_path__ + "img/quietComfort-45.2f8c1fb2.jpg";